import type { SessionRepository } from "@studystraight/session-core";
import { useEffect, useState } from "react";

import {
  IndexedDBSessionRepository,
  type StorageStatus,
} from "../platform/storage/IndexedDBSessionRepository.js";

export interface RepositoryState {
  /** `null` trong lúc đang mở database (thường vài chục ms). */
  repository: SessionRepository | null;
  status: StorageStatus | null;
  /** Có ít nhất một thao tác ghi/đọc thất bại (hết quota, DB bị xoá giữa phiên) — §27. */
  failed: boolean;
}

/**
 * Mở `SessionRepository` một lần cho cả app.
 *
 * Mở ở tầng App chứ không trong từng screen: Monitoring, History, Report và Settings đều cần cùng
 * một repository, và mở lại ở mỗi screen sẽ tạo nhiều connection IndexedDB tới cùng database —
 * đủ để một `deleteAll()` ở History bị `blocked` bởi connection của screen khác.
 */
export function useSessionRepository(): RepositoryState {
  const [state, setState] = useState<RepositoryState>({
    repository: null,
    status: null,
    failed: false,
  });

  useEffect(() => {
    let disposed = false;

    void IndexedDBSessionRepository.create({
      onError: () => {
        if (!disposed) setState((prev) => ({ ...prev, failed: true }));
      },
    }).then(({ repository, status }) => {
      // Giữ `prev.failed`: `onError` có thể đã bắn TRƯỚC khi `create()` resolve (lỗi ngay ở lần
      // mở database), và ghi đè `false` ở đây sẽ xoá đúng cảnh báo cần hiện nhất.
      if (!disposed) setState((prev) => ({ repository, status, failed: prev.failed }));
    });

    return () => {
      disposed = true;
    };
  }, []);

  return state;
}
